import { Box } from "@mui/material";
import React, { useState } from "react";
import LeftMenu, { DRAWER_WIDTH } from "./LeftMenu";
import TopBar from "./TopBar";

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileDrawerOpen(!mobileDrawerOpen);
  };

  return (
    <>
      {/* Top Bar - Fixed at top */}
      <TopBar />

      {/* Left Sidebar - Fixed on left */}
      <LeftMenu
        mobileOpen={mobileDrawerOpen}
        onMobileClose={handleDrawerToggle}
      />

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          marginLeft: { xs: 0, sm: `${DRAWER_WIDTH}px` },
          marginTop: "64px", // AppBar height
          minHeight: "calc(100vh - 64px)",
          backgroundColor: "background.default",
        }}
      >
        {children}
      </Box>
    </>
  );
};

export default Layout;
